import { TableHeaderCategoryConfig } from "../../../../../components/tables/tableContext/TableContext";

import { CollectionErrorsDataInterface } from "../../../../../redux/interfaces/reports.interface";
import { getDateAndTime } from "../../../../../utils/dateAndTime";

export const collectionErrorsDetailedTableHeader: TableHeaderCategoryConfig[] =
  [
    {
      label: "Username colector",
      value: "usernameColector",
      minW: 125,
    },
    {
      label: "Nume colector",
      value: "numeColector",
      minW: 125,
    },
    {
      label: "Username verificator",
      value: "usernameVerificator",
      minW: 125,
    },
    {
      label: "Nume verificator",
      value: "numeVerificator",
      minW: 125,
    },
    {
      label: "Produs",
      value: "produs",
      minW: 125,
    },
    {
      label: "Nr. comanda",
      value: "op",
      minW: 125,
    },
    {
      label: "Tip greseala",
      value: "tip",
      minW: 125,
    },
    {
      label: "Data verificarii",
      value: "dataVerificarii",
      minW: 125,
    },
  ];

export const getCollectionErrorsDetailedTableData: any = (
  collectionErrorsDetailedList: CollectionErrorsDataInterface[],
) =>
  collectionErrorsDetailedList?.map((item) => {
    const errorType = () => {
      if (item.cantitateMinus) {
        return "Cantitate minus";
      }
      if (item.cantitatePlus) {
        return "Cantitate plus";
      }
      if (item.lotBBD) {
        return "Lot si BBD";
      }

      return "-";
    };
    return {
      id: item.id_greseala,
      crudData: item,
      data: [
        {
          title: item.usernameColector,
        },
        {
          title: item.numeColector,
        },
        {
          title: item.usernameVerificator,
        },
        {
          title: item.numeVerificator,
        },
        {
          title: item.produs,
        },
        {
          title: item.op,
        },
        {
          badges: [
            {
              badgeText: errorType(),
              badgeColor: "light-info",
            },
          ],
        },
        {
          badges: [
            {
              badgeText: getDateAndTime(item.dataVerificarii) ?? "-",
              badgeColor: "light-primary",
            },
          ],
        },
      ],
    };
  });
